<script lang="ts">
  import { type SharedCustomDatasetTokenState } from './run-llm-unlearning-huggingface-datasets.svelte'
  import HuggingFaceTokenPicker from '@routes/huggingface-tokens/HuggingFaceTokenPicker.svelte'

  interface Props {
    state: SharedCustomDatasetTokenState
    visible: boolean
  }

  let { state, visible }: Props = $props()
</script>

{#if visible}
  <div class="card space-y-3 px-4 py-3">
    <label class="label flex items-center gap-2">
      <input type="checkbox" bind:checked={state.useToken} />
      Use the same HuggingFace token for all custom datasets
    </label>
    {#if state.useToken}
      <HuggingFaceTokenPicker
        bind:token={state.token}
        bind:tokenId={state.tokenId}
        bind:saveToken={state.saveToken}
        bind:tokenName={state.tokenName}
        customLabel="Shared HuggingFace token (optional)"
      />
    {/if}
  </div>
{/if}
